<template>
  <div class='main-content'>
    <el-row class="row-content">
      <el-col :md="12" class="content-left hidden-sm-and-down">
        <div class="bg-main-image" />
      </el-col>
      <el-col :md="12" :sm="24" class="content-right">
        <el-row>
          <el-col :span="24">
            <img class="logo" :src="nationalLogoAccount">
          </el-col>
        </el-row>
        <el-card class="box-card content-card">
          <slot />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'AccountLayout',
  computed: {
    nationalLogoAccount() {
      const customLogo = this.$store.getters['national/getLogo'];
      if (customLogo) {
        return `${customLogo}?v=${this.moment().valueOf()}`;
      }
      // eslint-disable-next-line global-require
      return process.env.VUE_APP_LOGO_ACCOUNT && process.env.VUE_APP_LOGO_ACCOUNT !== '' ? process.env.VUE_APP_LOGO_ACCOUNT : require('@/assets/logos/Assemble_Logo_RGB_Positive.png');
    },
  }
};
</script>

<style scoped lang="scss">
.main-content {
  width: 100%;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

.row-content {
  display: flex;
  flex: 1 1 auto;

  .content-left {
    display: flex;

    .bg-main-image {
      flex: 1 1 auto;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      background-image:url('~@/assets/illustrations/Assemble_Illustration_All in_Positive.png')
    }
  }

  .content-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 1em;
    padding-bottom: 1em;

    .content-card {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 1em;
      margin-right: 1em;
      margin-top: 2em;
      width: 90%;
      max-width: 30em;
    }
  }
}

::v-deep .el-card__body {
  width: 100%;
  max-width: $md;
}

.logo {
  height: 7em;
}
</style>
